import { useState, useEffect, useRef } from 'react';
import useSessionContext from '../data/queryHooks/useSessionContext';

const useManageDefaultLocation = () => {
	const { isLoading, flows } = useSessionContext();

	const [hasDefaultLocation, setHasDefaultLocation] = useState(true);
	const hasRan = useRef(false);

	useEffect(() => {
		if (!hasRan.current && !isLoading) {
			hasRan.current = true;

			if (flows.findIndex(item => item?.flow === 2) > -1) {
				setHasDefaultLocation(false);
			}
		}
	}, [isLoading]);

	return {
		hasDefaultLocation,
		setHasDefaultLocation,
	};
};

export default useManageDefaultLocation;
